/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Typography,
  IconButton,
  Paper,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { connect } from 'react-redux';
import MaterialTable from 'material-table';
import { useTranslation } from 'react-i18next';
import reportServices from '../../../redux/services/reportServices';
import reportImg from '../../../shared/img/report.png';
import disabledReportImg from '../../../shared/img/report_disabled.png';
import { generatePDF } from '../../Exports/components/EWExports/generateReport';
import { groupServices } from '../../../redux/services/groupServices';
import { uiActions } from '../../../redux/actions/uiActions';
import logo from '../../../shared/img/logo/logo.png';
import Empty from '../Shared/Empty';
import { formatDateWithYear } from '../../../helpers/utils';
import { edusignServices } from '../../../redux/services/edusignServices';
import { toastError } from '../../../redux/actions/alertActions';
import TitleAccessibility from '../../../shared/components/Title';
import { getLearnerPresencesSummary } from '../../../redux/services/dendreoServices';

const Reports = ({ user, setPageTitle, language }) => {
  const { i18n, t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const getReportsData = async () => {
    const reportsRes = await reportServices.getReportsByStudent(user._id);
    if (reportsRes && reportsRes.data && reportsRes.data.length > 0) {
      const reportsArr = [];
      await Promise.all(reportsRes.data.map(async (report) => {
        try {
          const groupRes = await groupServices.getGroupByCoursePlan(report.coursePlan._id);
          if (groupRes.language === language) {
            if (user.dendreoId) {
              const presenceSummary = await getLearnerPresencesSummary(
                report.coursePlan.dendreoAdfId,
                user.dendreoId,
              );
              if (presenceSummary && presenceSummary.summary) {
                reportsArr.push({
                  ...report,
                  presenceSummary: {
                    present: presenceSummary?.summary.total_hours_present,
                    missing: presenceSummary?.summary.total_hours_absent,
                    justified: presenceSummary?.summary.justified_absences_count,
                  },
                });
              } else {
                reportsArr.push({ ...report });
              }
            } else {
              reportsArr.push({ ...report });
            }
          }
        } catch (e) {
          toastError(e);
        }
      }));

      if (reportsArr && reportsArr.length > 0) {
        const sortedReports = reportsArr.sort((a, b) => new Date(b.coursePlan.beginDate) - new Date(a.coursePlan.beginDate));
        setReports(sortedReports);
      }
    }
    setLoading(false);
  };

  useEffect(async () => {
    setPageTitle(t('reports.pageTitle', 'Rapport(s) de fin de formation'));
    setLoading(true);
    getReportsData();
  }, [language]);

  const handleReport = (report) => {
    groupServices.getGroupByCoursePlan(report.coursePlan._id).then((groupRes) => {
      groupServices.getCoursePlan(groupRes._id).then((coursePlanRes) => {
        const coursePlan = coursePlanRes;
        let contentTitles = [];
        if (coursePlan !== undefined && coursePlan.coursePlan?.formationContent !== undefined) {
          const arr = [];
          let filteredContentTitles = [];
          coursePlan.coursePlan.formationContent.forEach((item) => {
            arr.push(...item.skillTitle);
          });
          const ids = arr.map((item) => item._id);
          filteredContentTitles = arr.filter(({ _id }, index) => !ids.includes(_id, index + 1));
          contentTitles = [...filteredContentTitles];
        }
        if (contentTitles !== undefined) {
          contentTitles.forEach((contentTitle) => {
            const content = [];
            contentTitle.skills.forEach((contentId) => {
              coursePlan.coursePlan.formationContent.forEach((contentObj) => {
                if (contentId === contentObj._id) {
                  content.push(contentObj);
                }
              });
            });
            contentTitle.content = content;
          });
        }
        let grade = null;
        if (coursePlan.listIdUsers && coursePlan.listIdUsers.length > 0) {
          coursePlan.listIdUsers.forEach((student) => {
            if (student._id === user._id) {
              grade = student.test;
            }
          });
        }
        if (coursePlan !== undefined) {
          const finalReport = { ...report };
          if (finalReport.customPresence !== undefined && finalReport.customPresence !== null && !Number.isNaN(finalReport.customPresence)) {
            finalReport.presenceSummary = {
              present: finalReport.customPresence,
              missing: (Number(coursePlan.coursePlan.duration) || 0) - (Number(finalReport?.customPresence) || 0),
              justified: 0,
            };
          }
          generatePDF(coursePlan, finalReport, user, grade, contentTitles, coursePlan.specificSkills, t, i18n.language);
        }
      });
    });
  };

  return (
    <>
      <TitleAccessibility title="Rapports de fin de formation" />
      <Paper style={{ padding: '30px', marginBottom: '30px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
            marginBottom: '20px',
          }}
        >
          <img src={logo} alt={t('reports.logoAlt', 'logo english world')} style={{ width: '100px' }} />
          <div>
            <Typography variant="body2" style={{ marginLeft: '30px', color: '#797979' }}>
              {t(
                'reports.intro',
                'Vous pouvez trouver sur cette page la liste de vos rapports de fin de formation et les télécharger au format PDF.',
              )}
            </Typography>
          </div>
        </div>
        <p
          id="reports-table-summary"
          style={{
            position: 'absolute',
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
        >
          Ce tableau liste vos rapports de fin de formation.
          Il liste chaque formation avec les colonnes suivantes: nom de la formation,
          date de début de la formation, date de fin de la formation, nombre d&apos;heures effectuées, statut du rapport (non effectué ou disponible)
          et bouton de téléchargement du rapport au format pdf (si validé).
          Les colonnes peuvent être triées et filtrées.
          Il y a également une barre de recherche permettant de faire un tri par nom de formation.
        </p>
      </Paper>

      {loading === false
        ? (
          <MaterialTable
            data={reports}
            title={t('reports.tableTitle', 'Rapport(s) de fin de formation')}
            style={{
              width: '100%',
              padding: '20px',
              minHeight: '60vh',
            }}
            columns={[
              {
                title: t('reports.columns.training', 'Formation'),
                field: 'groupName',
              },
              {
                title: t('reports.columns.beginDate', 'Date de début'),
                field: 'coursePlan.beginDate',
                render: ({ coursePlan }) => (
                  <Typography variant="body2">{formatDateWithYear(coursePlan.beginDate)}</Typography>
                ),
              },
              {
                title: t('reports.columns.endDate', 'Date de fin'),
                field: 'coursePlan.endDate',
                render: ({ coursePlan }) => (
                  <Typography variant="body2">{formatDateWithYear(coursePlan.endDate)}</Typography>
                ),
              },
              {
                title: t('reports.columns.attendance', 'Assiduité'),
                field: 'coursePlan.duration',
                render: ({ coursePlan, presenceSummary, customPresence }) => {
                  const totalHours = coursePlan?.duration ?? 'n/a';
                  const edusignHours = presenceSummary?.present;

                  if (customPresence !== undefined && customPresence !== null && !Number.isNaN(customPresence)) {
                    return (
                      <Typography variant="body2">
                        {customPresence}
                        {t('reports.hoursShort', 'h')}
                        {' / '}
                        {totalHours}
                        {t('reports.hoursShort', 'h')}
                      </Typography>
                    );
                  }

                  if (presenceSummary) {
                    return (
                      <Typography variant="body2">
                        {edusignHours}
                        {t('reports.hoursShort', 'h')}
                        {' / '}
                        {totalHours}
                        {t('reports.hoursShort', 'h')}
                      </Typography>
                    );
                  }

                  return (
                    <Typography variant="body2">
                      {t('reports.noPresence', 'Pas de présences')}
                    </Typography>
                  );
                },
              },
              {
                title: t('reports.columns.status', 'Status'),
                field: 'validation.status',
                render: (rowData) => {
                  if (rowData.validation.status === 'validated') {
                    return (
                      <Alert severity="success" variant="filled" style={{ width: '100%' }}>
                        {t('reports.status.ready', 'Rapport prêt')}
                      </Alert>
                    );
                  }
                  return (
                    <Alert severity="error" variant="filled" style={{ width: '100%' }}>
                      {t('reports.status.notFinished', 'Rapport non terminé')}
                    </Alert>
                  );
                },
              },
              {
                title: t('reports.columns.download', 'Télécharger'),
                field: 'report',
                align: 'center',
                render: (rowData) => {
                  if (rowData.validation.status === 'validated') {
                    return (
                      <IconButton
                        variant="contained"
                        onClick={() => handleReport(rowData)}
                        aria-label={t('reports.download.aria', 'Télécharger le rapport')}
                      >
                        <img src={reportImg} alt={t('reports.download.alt', 'Télécharger le PDF')} style={{ width: '60px' }} />
                      </IconButton>
                    );
                  }
                  return (
                    <IconButton
                      disabled
                      variant="contained"
                      aria-label={t('reports.download.disabledAria', 'Téléchargement indisponible')}
                    >
                      <img src={disabledReportImg} alt={t('reports.download.disabledAlt', 'Indisponible')} style={{ width: '60px' }} />
                    </IconButton>
                  );
                },
              },
            ]}
            components={{
              Paper: (props) => (
                <div
                  role="region"
                  aria-label="Liste des rapports de fin de formations"
                  aria-describedby="reports-table-summary"
                >
                  {props.children}
                </div>
              ),
            }}
          />
        )
        : <Empty message={t('reports.empty', "Désolé, vous n'avez pas de rapport(s) de fin de formation")} />}
    </>
  );
};

function mapState(state) {
  const { user } = state.user;
  const { language } = state.language;
  return {
    user, state, language,
  };
}

const actionCreators = {
  setPageTitle: uiActions.setPageTitle,
};

const connectedReports = connect(mapState, actionCreators)(Reports);
export default connectedReports;
